const mEditionMapEnrollmentsStudentsModalAdd = {
  mEditionMapEnrollmentsStudentsModalAdd: {
    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La acción fue procesada exitosamente.',
        required: 'Es necesario seleccionar una familia para continuar.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'AGREGAR',

    title: 'Agregar a Equipo'
  }
}

export default mEditionMapEnrollmentsStudentsModalAdd
